// Animated candlestick chart on canvas — drawn live with rAF
// Usage: new TRChart(canvasEl, { variant: 'tesla' | 'bank' | 'team45' | 'tbt' })

(function () {
  function rng(seed) {
    let s = seed >>> 0 || 1;
    return function () {
      s = (s * 1664525 + 1013904223) >>> 0;
      return s / 4294967296;
    };
  }

  function genCandles(seed, n, drift, vol) {
    const r = rng(seed);
    const candles = [];
    let p = 100;
    for (let i = 0; i < n; i++) {
      const o = p;
      const change = (r() - 0.5 + drift) * vol;
      const c = o + change;
      const wick = vol * (0.4 + r() * 0.7);
      const h = Math.max(o, c) + r() * wick;
      const l = Math.min(o, c) - r() * wick;
      candles.push({ o, h, l, c });
      p = c;
    }
    return candles;
  }

  const VARIANTS = {
    tesla:  { seed: 7,  drift: 0.06, vol: 1.6, hue: "#FF7A1A", labels: ["TSLA · 1H", "LONG @ 248.10", "TP1 +1.8%", "TP2 +3.2%"] },
    bank:   { seed: 13, drift: 0.04, vol: 1.2, hue: "#FFA15C", labels: ["JPM · 4H", "LIQ SWEEP", "BOS ↑", "ENTRY 218.40"] },
    team45: { seed: 21, drift: 0.05, vol: 1.4, hue: "#FF7A1A", labels: ["NQ1! · 15m", "MOMO ↑↑", "VWAP ↑", "RVOL 2.4×"] },
    tbt:    { seed: 33, drift: 0.07, vol: 1.5, hue: "#FFB47A", labels: ["BTC/USDT · 1H", "TBT CONFLUENCE 5/5", "STRONG LONG", "RR 3.6"] },
  };

  class TRChart {
    constructor(canvas, opts = {}) {
      this.canvas = canvas;
      this.ctx = canvas.getContext("2d");
      this.opts = opts;
      this.variant = opts.variant || "tesla";
      this.dpr = Math.min(window.devicePixelRatio || 1, 2);
      this.candles = [];
      this.targetCount = 60;
      this.tick = 0;
      this.resize();
      this.regen();
      this.animate = this.animate.bind(this);
      this.raf = requestAnimationFrame(this.animate);
      this.ro = new ResizeObserver(() => this.resize());
      this.ro.observe(canvas.parentElement || canvas);
    }
    setVariant(v) {
      this.variant = v;
      this.regen();
    }
    regen() {
      const v = VARIANTS[this.variant] || VARIANTS.tesla;
      this.candles = genCandles(v.seed + Math.floor(Date.now() / 50000), this.targetCount, v.drift, v.vol);
      this.cfg = v;
    }
    resize() {
      const r = this.canvas.getBoundingClientRect();
      this.W = r.width;
      this.H = r.height;
      this.canvas.width = Math.floor(this.W * this.dpr);
      this.canvas.height = Math.floor(this.H * this.dpr);
      this.ctx.setTransform(this.dpr, 0, 0, this.dpr, 0, 0);
    }
    animate() {
      this.tick++;
      // Every ~28 frames push a new candle
      if (this.tick % 28 === 0) {
        const last = this.candles[this.candles.length - 1];
        const r = rng(this.tick + this.cfg.seed);
        const o = last.c;
        const change = (r() - 0.5 + this.cfg.drift) * this.cfg.vol;
        const c = o + change;
        const wick = this.cfg.vol * (0.5 + r() * 0.6);
        const h = Math.max(o, c) + r() * wick;
        const l = Math.min(o, c) - r() * wick;
        this.candles.push({ o, h, l, c });
        if (this.candles.length > this.targetCount) this.candles.shift();
      }
      this.draw();
      this.raf = requestAnimationFrame(this.animate);
    }
    draw() {
      const ctx = this.ctx;
      const W = this.W, H = this.H;
      ctx.clearRect(0, 0, W, H);

      // Background gradient
      const bg = ctx.createLinearGradient(0, 0, 0, H);
      bg.addColorStop(0, "#0F0E10");
      bg.addColorStop(1, "#0A0A0B");
      ctx.fillStyle = bg;
      ctx.fillRect(0, 0, W, H);

      // Grid
      ctx.strokeStyle = "rgba(255,255,255,0.04)";
      ctx.lineWidth = 1;
      const gx = 8, gy = 6;
      for (let i = 1; i < gx; i++) {
        const x = (W / gx) * i;
        ctx.beginPath(); ctx.moveTo(x, 0); ctx.lineTo(x, H); ctx.stroke();
      }
      for (let i = 1; i < gy; i++) {
        const y = (H / gy) * i;
        ctx.beginPath(); ctx.moveTo(0, y); ctx.lineTo(W, y); ctx.stroke();
      }

      // Compute price range
      let min = Infinity, max = -Infinity;
      this.candles.forEach(c => { if (c.l < min) min = c.l; if (c.h > max) max = c.h; });
      const pad = (max - min) * 0.08;
      min -= pad; max += pad;
      const yScale = (p) => H - 36 - ((p - min) / (max - min)) * (H - 70);

      // Price line (orange highlight on close path - smoothed)
      ctx.strokeStyle = "rgba(255,122,26,0.35)";
      ctx.lineWidth = 1.2;
      ctx.beginPath();
      const cw = (W - 80) / this.candles.length;
      this.candles.forEach((c, i) => {
        const x = 20 + i * cw + cw / 2;
        const y = yScale(c.c);
        if (i === 0) ctx.moveTo(x, y); else ctx.lineTo(x, y);
      });
      ctx.stroke();

      // Candles
      this.candles.forEach((c, i) => {
        const x = 20 + i * cw + cw / 2;
        const up = c.c >= c.o;
        const color = up ? "#7BC894" : "#E25959";
        ctx.strokeStyle = color;
        ctx.fillStyle = color;
        ctx.lineWidth = 1;
        // wick
        ctx.beginPath();
        ctx.moveTo(x, yScale(c.h));
        ctx.lineTo(x, yScale(c.l));
        ctx.stroke();
        // body
        const bw = Math.max(2, cw * 0.6);
        const yo = yScale(c.o), yc = yScale(c.c);
        const top = Math.min(yo, yc), hgt = Math.max(1, Math.abs(yo - yc));
        if (up) {
          ctx.fillStyle = "rgba(123,200,148,0.18)";
          ctx.fillRect(x - bw / 2, top, bw, hgt);
          ctx.strokeStyle = color;
          ctx.strokeRect(x - bw / 2 + 0.5, top + 0.5, bw - 1, hgt - 1);
        } else {
          ctx.fillStyle = color;
          ctx.fillRect(x - bw / 2, top, bw, hgt);
        }
      });

      // Last close marker
      const last = this.candles[this.candles.length - 1];
      const lastX = 20 + (this.candles.length - 1) * cw + cw / 2;
      const lastY = yScale(last.c);
      // dashed line
      ctx.setLineDash([3, 4]);
      ctx.strokeStyle = "rgba(255,122,26,0.6)";
      ctx.beginPath();
      ctx.moveTo(20, lastY);
      ctx.lineTo(W - 60, lastY);
      ctx.stroke();
      ctx.setLineDash([]);
      // price tag
      ctx.fillStyle = "#FF7A1A";
      ctx.fillRect(W - 64, lastY - 10, 56, 20);
      ctx.fillStyle = "#0A0A0B";
      ctx.font = "600 11px JetBrains Mono, monospace";
      ctx.textAlign = "center"; ctx.textBaseline = "middle";
      ctx.fillText(last.c.toFixed(2), W - 36, lastY);

      // Labels (top-left)
      ctx.textAlign = "left"; ctx.textBaseline = "top";
      ctx.font = "600 11px JetBrains Mono, monospace";
      ctx.fillStyle = "#F5F2EE";
      ctx.fillText(this.cfg.labels[0], 16, 14);
      ctx.font = "500 10px JetBrains Mono, monospace";
      ctx.fillStyle = "#FF7A1A";
      this.cfg.labels.slice(1).forEach((lbl, i) => {
        const tx = 16; const ty = 32 + i * 14;
        const tw = ctx.measureText(lbl).width + 10;
        ctx.fillStyle = "rgba(255,122,26,0.12)";
        ctx.fillRect(tx - 4, ty - 2, tw, 14);
        ctx.fillStyle = "#FF7A1A";
        ctx.fillText(lbl, tx, ty);
      });

      // Volume bars at bottom (last 30)
      const vh = 26;
      const vy = H - vh - 4;
      const visibleVols = this.candles.slice(-this.candles.length);
      visibleVols.forEach((c, i) => {
        const x = 20 + i * cw + cw / 2;
        const up = c.c >= c.o;
        const v = Math.abs(c.c - c.o) + 0.4;
        const h = Math.min(vh, v * 6);
        ctx.fillStyle = up ? "rgba(123,200,148,0.45)" : "rgba(226,89,89,0.45)";
        ctx.fillRect(x - cw * 0.3, vy + (vh - h), cw * 0.6, h);
      });
    }
    destroy() {
      cancelAnimationFrame(this.raf);
      this.ro && this.ro.disconnect();
    }
  }

  window.TRChart = TRChart;
})();
